import { observer } from 'mobx-react-lite'
import { FullPageWrapper, SpinnerLoader } from 'shared/ui'
import { ReviewsProvider, useReviewsContext } from 'pages/reviews/context/reviewsContext'
import { ReviewsPageEmpty } from 'pages/reviews/ui/ReviewsPageEmpty/ReviewsPageEmpty'

const Reviews = observer(() => {
  const { isLoading, isEmpty } = useReviewsContext()

  if (isLoading) {
    return <SpinnerLoader ariaLabel={'reviewsPage'} />
  }

  if (isEmpty) {
    return <ReviewsPageEmpty />
  }

  return <FullPageWrapper />
})

export const ReviewsPage = () => (
  <ReviewsProvider>
    <Reviews />
  </ReviewsProvider>
)
